/**
 * Created with setting codegen.
 */
import { featureToggle } from "@faire/web/common/settings/declarations/featureToggle";

/**
 * Enable Hotjar session recording.
 */
export const FE_ENABLE_HOTJAR_SESSION_RECORDING_251001 = featureToggle({
  name: "FE_ENABLE_HOTJAR_SESSION_RECORDING_251001",
  identifier: "RetailerTokenOrBrandTokenOrLoggedOutSessionToken",
  defaultValue: false,
  client: ["RETAILER", "VISITOR_WEB", "MAKER"],
  productArea: "HOTJAR_CONFIG",
  notifyAfter: "2026-01-01",
});
